const React = require('react')

module.exports = { 
      attributes: {"nl":{"statement":"Jouw privacy is belangrijk voor ons! 🍪 We gebruiken cookies om je ervaring te verbeteren en de websiteverkeer te analyseren. Door op 'Accepteren' te klikken, ga je akkoord met ons gebruik van cookies zoals beschreven in ons Privacy Policy.","privacy_policy_link_text":"Privacybeleid","accept":"Accepteren","decline":"Afwijzen"},"en":{"statement":"Your privacy matters to us! 🍪 We use cookies to enhance your experience and analyze site traffic. By clicking 'Accept', you agree to our use of cookies as outlined in our Privacy Policy.","privacy_policy_link_text":"Privacy Policy","accept":"Accept","decline":"Decline"}},
    
      react: 
      function (props) {
        Object.keys(props).forEach(function (key) {
          this[key] = props[key]
        })
        const markdown = /*#__PURE__*/React.createElement("div", {
  className: "frontmatter-markdown"
});
        return markdown
      }
    ,
     }